import { useEffect, useState } from 'react'
import { authedAxios } from '../../utils'

import { useStore } from '../../store'
import { BUSINESS_TYPES_ACTIONS } from '../../store/businessTypes'

const useBusinessTypes = () => {
  const { state, dispatch } = useStore()

  const { businessTypes, businessTypesExp } = state

  const setBusinessTypes = (data) =>
    dispatch({
      type: BUSINESS_TYPES_ACTIONS.SET_BUSINESS_TYPES,
      businessTypes: data,
    })

  const [isLoading, setIsLoading] = useState(true)
  const [hasLoadError, setHasLoadError] = useState(false)

  const getBusinessTypes = () => {
    if (businessTypes?.length > 0 && Date.now() < businessTypesExp) {
      return setIsLoading(false)
    }

    return authedAxios
      .get('/api/company/business-type')
      .then((res) => {
        setBusinessTypes(res.data.businessTypes)
      })
      .catch(() => {
        setHasLoadError(true)
      })
      .finally(() => setIsLoading(false))
  }

  useEffect(() => {
    getBusinessTypes()
  }, [])

  return { businessTypes, setBusinessTypes, isLoading, hasLoadError }
}

export default useBusinessTypes
